import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { compact } from 'lodash-es';
import { InvoiceDisplayStatus, InvoiceDisplayStatusV2, InvoicePaymentDisplayStatusType, PaymentDetailType } from 'anchor-scout-common/types';
import { AccountingStatusFilter } from '~/business-logic/qboStatusFilterLogic';
import { SearchFilterType } from '~/components/TableFilters/types';
import { DateFilterPicker, DateFilterPickerPresets } from './DateFilterPicker';
export const invoiceFilterTextsPath = 'invoice';
export var FilterType = /*#__PURE__*/ function(FilterType) {
    FilterType["InvoiceStatus"] = "invoiceStatus";
    FilterType["PaymentStatus"] = "paymentStatus";
    FilterType["Date"] = "date";
    FilterType["QboSync"] = "qboSync";
    FilterType["XeroSync"] = "xeroSync";
    FilterType["IssuesPreventingPayment"] = "issuesPreventingPayment";
    FilterType["ProcessedBy"] = "processedBy";
    return FilterType;
}({});
export function getTableFilterLabels(filterLabels) {
    return {
        ["invoiceStatus"]: filterLabels.invoiceStatus(),
        ["paymentStatus"]: filterLabels.paymentStatus(),
        ["date"]: filterLabels.date(),
        ["qboSync"]: filterLabels.qboSync(),
        ["xeroSync"]: filterLabels.xeroSync(),
        ["issuesPreventingPayment"]: filterLabels.issuesPreventingPayment(),
        ["processedBy"]: filterLabels.processedBy()
    };
}
export function getActiveFilterGroups(params) {
    if (params.INVOICE_STATUSES_V2) {
        const allFilters = compact([
            "invoiceStatus",
            "date",
            params.showQboIntegration && params.hasQboFilterOptions && "qboSync",
            params.showXeroIntegration && params.hasXeroFilterOptions && "xeroSync",
            "issuesPreventingPayment",
            params.isVendor && "processedBy"
        ]);
        return [
            {
                label: '',
                filters: allFilters
            }
        ];
    }
    const invoiceFilters = [
        "invoiceStatus",
        "paymentStatus",
        "date"
    ];
    const accountingFilters = compact([
        params.showQboIntegration && params.hasQboFilterOptions && "qboSync",
        params.showXeroIntegration && params.hasXeroFilterOptions && "xeroSync"
    ]);
    return compact([
        {
            label: params.filterGroupLabels.invoice(),
            filters: invoiceFilters
        },
        accountingFilters.length > 0 && {
            label: params.filterGroupLabels.accounting(),
            filters: accountingFilters
        }
    ]);
}
function invoiceDisplayStatusLabels(labels) {
    return {
        [InvoiceDisplayStatus.Issued]: labels.issued(),
        [InvoiceDisplayStatus.Overdue]: labels.overdue(),
        [InvoiceDisplayStatus.PaymentInitiated]: labels.processing(),
        [InvoiceDisplayStatus.Paid]: labels.paid(),
        [InvoiceDisplayStatus.Voided]: labels.voided(),
        [InvoiceDisplayStatus.Refunded]: labels.refunded(),
        [InvoiceDisplayStatus.RefundFailed]: labels.refundFailed(),
        [InvoiceDisplayStatus.PaymentDisputed]: labels.disputed(),
        [InvoiceDisplayStatus.PartiallyRefunded]: labels.partiallyRefunded()
    };
}
function invoiceDisplayStatusV2Labels(labels) {
    return {
        [InvoiceDisplayStatusV2.Issued]: labels.issued(),
        [InvoiceDisplayStatusV2.Pending]: labels.pending(),
        [InvoiceDisplayStatusV2.Overdue]: labels.overdue(),
        [InvoiceDisplayStatusV2.Processing]: labels.processing(),
        [InvoiceDisplayStatusV2.Paid]: labels.paid(),
        [InvoiceDisplayStatusV2.Voided]: labels.voided(),
        [InvoiceDisplayStatusV2.Refunded]: labels.refunded(),
        [InvoiceDisplayStatusV2.RefundFailed]: labels.refundFailed(),
        [InvoiceDisplayStatusV2.Disputed]: labels.disputed(),
        [InvoiceDisplayStatusV2.PartiallyRefunded]: labels.partiallyRefunded()
    };
}
function paymentDisplayStatusLabels(labels) {
    return {
        [InvoicePaymentDisplayStatusType.None]: labels.none(),
        [InvoicePaymentDisplayStatusType.Collected]: labels.collected(),
        [InvoicePaymentDisplayStatusType.Paid]: labels.deposited(),
        [InvoicePaymentDisplayStatusType.PaidExternally]: labels.paidExternally(),
        [InvoicePaymentDisplayStatusType.PaymentFailed]: labels.paymentFailed(),
        [InvoicePaymentDisplayStatusType.PaymentMethodNotSet]: labels.paymentMethodNotSet(),
        [InvoicePaymentDisplayStatusType.PaymentMethodUnverified]: labels.paymentMethodNotVerified(),
        [InvoicePaymentDisplayStatusType.Pending]: labels.issued(),
        [InvoicePaymentDisplayStatusType.Processing]: labels.paymentInitiated(),
        [InvoicePaymentDisplayStatusType.Refunded]: labels.refundInitiated(),
        [InvoicePaymentDisplayStatusType.RefundFailed]: labels.refundFailed(),
        [InvoicePaymentDisplayStatusType.RequiresPaymentApproval]: labels.approvalRequired(),
        [InvoicePaymentDisplayStatusType.RequiresPaymentValidation]: labels.validationRequired(),
        [InvoicePaymentDisplayStatusType.StoppedPayment]: labels.stoppedPayment(),
        [InvoicePaymentDisplayStatusType.Disputed]: labels.disputed(),
        [InvoicePaymentDisplayStatusType.RefundRequested]: labels.refundRequested()
    };
}
function datePresetLabels(labels) {
    return {
        [DateFilterPickerPresets.AllTime]: labels.allTime(),
        [DateFilterPickerPresets.Today]: labels.today(),
        [DateFilterPickerPresets.ThisWeek]: labels.thisWeek(),
        [DateFilterPickerPresets.ThisMonth]: labels.thisMonth(),
        [DateFilterPickerPresets.PreviousMonth]: labels.previousMonth(),
        [DateFilterPickerPresets.LastThreeMonths]: labels.lastThreeMonths()
    };
}
function accountingStatusLabels(labels) {
    return {
        [AccountingStatusFilter.All]: labels.all(),
        [AccountingStatusFilter.Synced]: labels.synced(),
        [AccountingStatusFilter.NotSynced]: labels.notSynced()
    };
}
function paymentDetailLabels(labels) {
    return {
        [PaymentDetailType.MissingPaymentMethod]: labels.missingPaymentMethod(),
        [PaymentDetailType.PaymentMethodNotVerified]: labels.paymentMethodNotVerified(),
        [PaymentDetailType.ClientApprovalRequired]: labels.clientApprovalRequired(),
        [PaymentDetailType.PaymentStopped]: labels.paymentStoppedFilter(),
        [PaymentDetailType.PaymentValidationRequired]: labels.paymentValidationRequired(),
        [PaymentDetailType.PaymentAwaitingInitiation]: labels.paymentAwaitingInitiation(),
        [PaymentDetailType.PaymentScheduled]: labels.paymentScheduled({
            date: ''
        }),
        [PaymentDetailType.PaymentInitiated]: labels.paymentInitiated(),
        [PaymentDetailType.PaymentCollected]: labels.paymentCollected(),
        [PaymentDetailType.RefundRequested]: labels.refundRequested(),
        [PaymentDetailType.Refunded]: labels.refunded({
            date: ''
        }),
        [PaymentDetailType.PaidExternally]: labels.paidExternally({
            date: ''
        }),
        [PaymentDetailType.PaymentFailed]: labels.paymentFailedFilter(),
        [PaymentDetailType.PaidOnDate]: labels.paidOnDate({
            date: ''
        }),
        [PaymentDetailType.Voided]: labels.voided({
            date: ''
        }),
        [PaymentDetailType.Disputed]: labels.disputed({
            date: ''
        }),
        [PaymentDetailType.RefundFailed]: labels.refundFailed({
            date: ''
        })
    };
}
function InvoiceDateFilter(param) {
    let { value, onChange } = param;
    return /*#__PURE__*/ _jsx(DateFilterPicker, {
        value: value,
        onChange: onChange
    });
}
// TODO: Meital// when merging INVOICE_STATUSES_V2, restore return type to Record<FilterType, FilterConfig>
export function getTableFilterConfig(params) {
    return {
        ["invoiceStatus"]: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: params.invoiceStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    counter: o.counter
                }))
        },
        ["paymentStatus"]: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: params.paymentStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    counter: o.counter
                }))
        },
        ["date"]: {
            type: SearchFilterType.CustomFilter,
            removable: false,
            component: InvoiceDateFilter,
            initialValue: DateFilterPickerPresets.AllTime
        },
        ["qboSync"]: {
            type: SearchFilterType.RadioFilter,
            removable: false,
            options: params.qboStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    sublabel: "(".concat(o.counter, ")")
                })),
            defaultOption: AccountingStatusFilter.All
        },
        ["xeroSync"]: {
            type: SearchFilterType.RadioFilter,
            removable: false,
            options: params.xeroStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    sublabel: "(".concat(o.counter, ")")
                })),
            defaultOption: AccountingStatusFilter.All
        }
    };
}
export function getTableFilterConfigV2(params) {
    return {
        ["invoiceStatus"]: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: params.invoiceStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    counter: o.counter
                }))
        },
        ["date"]: {
            type: SearchFilterType.CustomFilter,
            removable: false,
            component: InvoiceDateFilter,
            initialValue: DateFilterPickerPresets.AllTime
        },
        ["qboSync"]: {
            type: SearchFilterType.RadioFilter,
            removable: true,
            options: params.qboStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    sublabel: "(".concat(o.counter, ")")
                })),
            defaultOption: AccountingStatusFilter.All
        },
        ["xeroSync"]: {
            type: SearchFilterType.RadioFilter,
            removable: true,
            options: params.xeroStatusFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    sublabel: "(".concat(o.counter, ")")
                })),
            defaultOption: AccountingStatusFilter.All
        },
        ["issuesPreventingPayment"]: {
            type: SearchFilterType.MultiSelectFilter,
            removable: true,
            hideSelectAll: true,
            options: params.issuesPreventingPaymentFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    counter: o.counter
                }))
        },
        ["processedBy"]: {
            type: SearchFilterType.MultiSelectFilter,
            removable: true,
            options: params.processedByFilterOptions.map((o)=>({
                    value: o.value,
                    label: o.label,
                    counter: o.counter
                }))
        }
    };
}
export function formatFilterDescription(params) {
    const { filterType, value, texts } = params;
    switch(filterType){
        case "invoiceStatus":
            {
                const statuses = value;
                if (!statuses.length) return undefined;
                const v1Labels = invoiceDisplayStatusLabels(texts.invoiceDisplayStatusLabels);
                const v2Labels = invoiceDisplayStatusV2Labels(texts.invoiceDisplayStatusLabels);
                const allLabels = _object_spread({}, v1Labels, v2Labels);
                return statuses.map((s)=>allLabels[s]).join(', ');
            }
        case "paymentStatus":
            {
                const statuses = value;
                if (!statuses.length) return undefined;
                const labels = paymentDisplayStatusLabels(texts.paymentDisplayStatusLabels);
                return statuses.map((s)=>labels[s]).join(', ');
            }
        case "date":
            {
                const labels = datePresetLabels(texts.datePresetLabels);
                return labels[value];
            }
        case "qboSync":
        case "xeroSync":
            {
                const labels = accountingStatusLabels(texts.accountingStatusLabels);
                return labels[value];
            }
        case "issuesPreventingPayment":
            {
                const details = value;
                if (!details.length) return undefined;
                const labels = paymentDetailLabels(texts.paymentDetailLabels);
                return details.map((d)=>labels[d]).join(', ');
            }
        case "processedBy":
            {
                const details = value;
                if (!details.length) return undefined;
                const labels = {
                    anchor: texts.processedByLabels.anchor(),
                    external: texts.processedByLabels.external()
                };
                return details.map((d)=>labels[d]).join(', ');
            }
    }
}
